import { Switch } from 'antd-mobile'
import React from 'react'

import { getTypeof } from '@/utils'

import { publicProps } from '../utils'
import './index.less'

function HSwitch(props: any) {
  const val = 'checked' in props ? props.checked : props.value
  if (props.readed) {
    return ['否', '是'][Number(val || 0)]
  }
  return <Switch checked={Boolean(val)} {...publicProps(props, 'switch')} />
}

HSwitch.transform = (value?: any, defaultValue = 1) => {
  if (getTypeof(value) === 'Boolean') {
    return value ? 1 : 0
  }
  if (getTypeof(value) === 'Number') {
    return value
  }
  if (getTypeof(value) === 'Null' || getTypeof(value) === 'Undefined') {
    return 0
  }
  return [1, 0].includes(defaultValue) ? defaultValue : 1
}

export default HSwitch
